import {
  discoveryApiRef,
  identityApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { useCallback } from 'react';

const fetchFile = async ({
  baseUrl,
  token,
  pathname,
}: {
  baseUrl: string;
  token?: string;
  pathname: string;
}): Promise<string | null> => {
  const response = await fetch(`${baseUrl}/${pathname}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (response.status !== 200) {
    return null;
  }
  const blob = await response.blob();
  return URL.createObjectURL(blob);
};

export function useFetchFile(): (ref: string) => Promise<string | null> {
  const discoveryApi = useApi(discoveryApiRef);
  const identityApi = useApi(identityApiRef);

  const fetchResponse = useCallback(
    async (ref: string) => {
      const baseUrl = await discoveryApi.getBaseUrl('cxone');
      const path = `file/${ref}`;
      const { token } = await identityApi.getCredentials();

      return fetchFile({
        baseUrl,
        token,
        pathname: path,
      });
    },
    [discoveryApi, identityApi],
  );

  return fetchResponse;
}
